export default __webpack_public_path__ + "static/media/Facebook-Logo.3393e104.png";